import React, { useEffect, useState } from 'react';
import styles from './index.module.css';
import { DotLottiePlayer } from '@dotlottie/react-player';

interface ToastProps {
  message: string;
  icon?: React.ReactNode;
  align?: 'center' | 'left';
  duration?: number;
  onClose?: () => void;
  autoClose?: boolean;
}

const Toast: React.FC<ToastProps> = ({
  message,
  icon,
  align = 'center',
  duration = 3000,
  onClose,
  autoClose = true,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (autoClose) {
        setIsVisible(false);
      }
      if (onClose) {
        setTimeout(onClose, 300); // Wait for animation to complete
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`${styles.toastContainer} ${isVisible ? styles.show : styles.hide} ${align === 'left' ? styles.alignLeft : ''}`}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.message}>{message}</span>
    </div>
  );
};

export default Toast;
